import { POWER_TOGGLE, BANK_TOGGLE, CHANGE_VOLUME, DISPLAY_BUTTON_NAME } from './types';

export const powerToggle = () => dispatch => {
	console.log('Power');
	dispatch({
		type: POWER_TOGGLE
	});
};

export const bankToggle = () => dispatch => {
	dispatch({
		type: BANK_TOGGLE	
	});
};

export const volumeChange = (volume) => dispatch => {
	dispatch({
		type: CHANGE_VOLUME,
		payload: volume
	});
};

export const updateButtonText = text => dispatch => {
	dispatch({
		type: DISPLAY_BUTTON_NAME,
		payload: text 
	});
};
